import { useLang } from "../i18n/LanguageContext";

const EditorialMarquee = () => {
  const { t } = useLang();
  const items = t.marquee;

  return (
    <div className="relative bg-[#D96B27] overflow-hidden border-y border-[#0D0F12]/30" data-testid="editorial-marquee">
      <div className="marquee-track items-center py-4 md:py-5" style={{ "--dur": "42s" }}>
        {[0, 1].map((dup) => (
          <div key={dup} aria-hidden={dup === 1} className="flex shrink-0 items-center">
            {items.map((it, i) => (
              <span
                key={i}
                className="flex items-center font-display font-extrabold uppercase tracking-tight text-[#0D0F12] text-2xl md:text-4xl whitespace-nowrap"
              >
                <span className="px-6 md:px-8">{it}</span>
                <span className="w-2.5 h-2.5 md:w-3 md:h-3 bg-[#0D0F12] rotate-45 inline-block shrink-0" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default EditorialMarquee;
